// extracted by mini-css-extract-plugin
module.exports = {"footerTextInformation":"FooterComponent_footerTextInformation__GtiLg"};